

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Typography,
  Button,
  Card as MuiCard,
  CardMedia,
  CardContent,
  Stack

} from "@mui/material";
import { styled } from "@mui/system";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Container, Skeleton } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FilterDataCard from "../../components/common/FilterDataCard";
import PlotSlider from "../../components/common/FeaturedCard";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import { get_market_fun } from "../../api/ControllApi";
import IconButton from "@mui/material/IconButton";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import PlotMarketListView from "./PlotMarketListView";
import { useSettings } from "../../context/Settings";
import DescriptionNote from "../../components/common/DescriptionNote";

const Card = styled(MuiCard)(({ theme }) => ({
  maxWidth: 345,
  margin: "auto",
  borderRadius: theme.spacing(2),
  overflow: "hidden",
}));

export default function PlotMarket() {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const [marketData, setMarketData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("grid");

  const [propertyType, setPropertyType] = useState([])
  const [resp, setResp] = useState([])
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const fetchMarketPlots = async (filters = {}, page = 1) => {
    setLoading(true);

    try {
      const params = {};

      // only add a param if it has a value
      if (filters.country_id) params.country_id = filters.country_id;
      if (filters.state_id) params.state_id = filters.state_id;
      if (filters.city_id) params.city_id = filters.city_id;
      // if (filters.plotType) params.plot_type = filters.plotType;
      if (filters.plotType && filters.plotType.length > 0) {
        params['plot_type[]'] = filters.plotType; // send array directly
      }




      if (filters.priceRange && filters.priceRange.length === 2) {
        // send only if user changed from undefined
        params.min_price = filters.priceRange[0];
        params.max_price = filters.priceRange[1];
      }

      if (filters.areaRange && filters.areaRange.length === 2) {
        params.min_sqft = filters.areaRange[0];
        params.max_sqft = filters.areaRange[1];
      }

      if (filters.searchQuery?.trim()) params.search = filters.searchQuery.trim();

      // Only log params that are actually sent

      const res = Object.keys(params).length > 0 || page > 0
        ? await get_market_fun(params, page) // send params if any
        : await get_market_fun();      // initial load → no params

      setResp(res?.data);
      setMarketData(res?.data?.market || []);
      setPropertyType(res?.data?.property_type || []);
      setPagination(
        res?.data?.pagination || { current_page: 1, last_page: 1 }
      );
    } catch (err) {

      setMarketData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMarketPlots(filters, page);
  }, [filters, page]);


  const handlePageChange = (page) => {
    setPage(page);
    setPagination((prev) => ({ ...prev, current_page: page }));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setPage(1);
  }, []);

  // const getMarketPlace = () => {
  //   setLoading(true);
  //   get_market_fun()
  //     .then((res) => {
  //       setMarketData(res?.data.market);
  //     })
  //     .catch((err) => {

  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   getMarketPlace();
  // }, []);





  return (


    <Container sx={{ py: 5 }}>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <BreadcrumbsNav />
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate("/add-property")}
          sx={{ borderRadius: '20px', px: 2, fontSize: '14px', fontWeight: 'bold' }}
        >
          Add Land +
        </Button>
      </Box>
      {settings?.data?.land_description && (
        <DescriptionNote description={settings.data.land_description} />
      )}
      <Box display="flex" justifyContent="flex-end" mr={2.5}>
        <IconButton color={view === "grid" ? "primary" : "default"} onClick={() => setView("grid")}>
          <Box key={view === "grid" ? "grid-active" : "grid-idle"} component="span"
            sx={{ display: "flex", ...(view === "grid" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(-20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewModuleIcon />
          </Box>
        </IconButton>
        <IconButton color={view === "list" ? "primary" : "default"} onClick={() => setView("list")}>
          <Box key={view === "list" ? "list-active" : "list-idle"} component="span"
            sx={{ display: "flex", ...(view === "list" && { animation: "iconPop 0.28s ease", "@keyframes iconPop": { "0%": { transform: "scale(0.55) rotate(20deg)", opacity: 0.4 }, "65%": { transform: "scale(1.22)", opacity: 1 }, "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 } } }) }}>
            <ViewListIcon />
          </Box>
        </IconButton>
      </Box>


      <Box
        sx={{
          display: { sm: "block", lg: "flex" },
          gap: 0.5,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: { xs: "80%", sm: "50%", lg: 0 },
            mx: "auto",
            flex: { xs: "0 0 50%", sm: "0 0 50%", md: "0 0 22%" },
            position: { xs: "static", lg: "sticky" }, // sticky only on desktop
            top: { md: 110 }, // top offset only for desktop
            mb: { xs: 2, md: 0 }, // spacing for mobile
          }}
        >
          <FilterDataCard
            onFilterChange={handleFilterChange}
            PropertyType={propertyType}
            priceMax={resp?.price_max}
            priceMin={resp?.price_min}
            stateList={resp?.state_list}
            areaMax={resp?.sqft_max}
            areaMin={resp?.sqft_min}
          />        </Box>
        <Box
          key={view}
          sx={{
            flex: 1,
            display: "grid",
            gridTemplateColumns:
              view === "grid"
                ? {
                  xs: "1fr",
                  sm: "0.5fr 0.5fr",
                  md: "1fr 1fr",
                  lg: "1fr 1fr",
                }
                : {
                  xs: "1fr",
                  sm: "1fr",
                  md: "1fr",
                  lg: "1fr",
                },
            ml: { xs: 0, lg: 8 },
            mt: { xs: 3, lg: 0 },
            px: 2,
            py: 2,
            gap: 2,
            // container entrance
            animation: "viewEnter 0.35s cubic-bezier(0.34,1.2,0.64,1) both",
            "@keyframes viewEnter": {
              "0%": { opacity: 0, transform: "scale(0.97) translateY(14px)" },
              "60%": { opacity: 1, transform: "scale(1.005) translateY(-2px)" },
              "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
            },
            // stagger each direct child card
            "& > *": {
              animation: "cardSlideIn 0.42s cubic-bezier(0.34,1.2,0.64,1) both",
              "@keyframes cardSlideIn": {
                "0%": { opacity: 0, transform: "translateY(20px) scale(0.96)" },
                "70%": { opacity: 1, transform: "translateY(-3px) scale(1.01)" },
                "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
              },
            },
            "& > *:nth-of-type(1)": { animationDelay: "0.04s" },
            "& > *:nth-of-type(2)": { animationDelay: "0.09s" },
            "& > *:nth-of-type(3)": { animationDelay: "0.14s" },
            "& > *:nth-of-type(4)": { animationDelay: "0.19s" },
            "& > *:nth-of-type(5)": { animationDelay: "0.24s" },
            "& > *:nth-of-type(6)": { animationDelay: "0.29s" },
            "& > *:nth-of-type(n+7)": { animationDelay: "0.32s" },
          }}
        >
          {loading ? (

            Array.from(new Array(4)).map((_, index) => (
              view !== "grid" ?
                <Box
                  key={index}
                  sx={{
                    width: "100%",
                    maxWidth: 780,
                    height: 270,
                    backgroundColor: "#f0f0f0",
                    borderRadius: 5,
                    display: "flex",
                    flexDirection: { xs: "column-reverse", lg: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: { xs: 2, md: 5 },
                    ml: { xs: 0, lg: 4 },
                    py: { xs: 4, md: 3 },
                    gap: { xs: 2, md: 3 },
                    opacity: 0,
                    animation: `skelFadeIn 0.4s ease forwards`,
                    animationDelay: `${index * 0.08}s`,
                    "@keyframes skelFadeIn": {
                      from: { opacity: 0, transform: "translateY(12px)" },
                      to: { opacity: 1, transform: "translateY(0)" },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "100%", sm: "42%" },
                      height: 225,
                      maxWidth: 400,
                      aspectRatio: "4/3",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
                  </Box>
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Skeleton variant="text" width="60%" height={30} animation="wave" />
                    <Skeleton variant="text" width="40%" height={20} animation="wave" />
                    <Skeleton variant="text" width="80%" height={20} animation="wave" />
                    <Skeleton variant="rectangular" width="100px" height={40} animation="wave" sx={{ borderRadius: 2 }} />
                  </Box>
                </Box>
                :
                <Box
                  key={index}
                  sx={{
                    borderRadius: 4,
                    p: 1,
                    overflow: "hidden",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    bgcolor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    opacity: 0,
                    animation: `skelFadeIn 0.4s ease forwards`,
                    animationDelay: `${index * 0.08}s`,
                    "@keyframes skelFadeIn": {
                      from: { opacity: 0, transform: "translateY(12px)" },
                      to: { opacity: 1, transform: "translateY(0)" },
                    },
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      width: "100%",
                      height: { xs: 180, sm: 220 },
                      borderRadius: 3,
                    }}
                    animation="wave"
                  />
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", py: 1 }}>
                    <Box>
                      <Skeleton variant="text" width="60%" height={28} animation="wave" />
                      <Skeleton variant="text" width="40%" height={22} animation="wave" sx={{ mt: 1 }} />
                      <Skeleton variant="text" width="50%" height={28} animation="wave" sx={{ mt: 2 }} />
                      <Skeleton variant="text" width="30%" height={20} animation="wave" sx={{ mt: 1 }} />
                    </Box>
                    <Skeleton variant="rectangular" height={42} animation="wave" sx={{ borderRadius: 2, mt: 2 }} />
                  </Box>
                </Box>
            ))
          ) : marketData.length === 0 ? (

            <Box
              sx={{
                gridColumn: "1 / -1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
                textAlign: "center",
                width: "100%",
                py: 5,
              }}
            >
              <Box
                component="img"
                src="/assets/images/nodatafound.png"
                alt="No Data Found"
                sx={{ width: { xs: 320, sm: 350, md: 380 }, mb: 2 }}
              />
            </Box>
          ) : (

            marketData.map((card, index) => (
              <Box sx={{ mb: 1.5 }} key={card.id}>
                {view === "grid" ? (
                  <PlotSlider
                    key={card?.id || index}
                    image={card?.image?.[0]}
                    totalPrice={card?.price}
                    area={card?.area}
                    id={card?.id}
                    verified={card?.verify_status}
                    isGeo={true}
                    postedOn={card?.created_at}
                    lastUpdate={card?.updated_at}
                    name={card?.name}
                    subText={card?.description}
                    address={`${card?.city?.city_name || ""}, ${card?.state?.state_name || ""
                      }`}
                    soldStatus={card?.sold_status}
                  />
                ) : (
                  <PlotMarketListView image={card?.image?.[0]} key={card?.id || index}
                    id={card?.id}
                    price={card?.price}
                    area={card?.area}
                    postedOn={card?.created_at}
                    verified={card?.verify_status}
                    lastUpdate={card?.updated_at}
                    description={card?.description}
                    name={card?.name} address={`${card?.city?.city_name || ""}, ${card?.state?.state_name || ""
                      }`}
                    soldStatus={card?.sold_status} />
                )}
              </Box>
            ))

            // marketData.map((card, index) => (
            //   <PlotSlider
            //     key={card?.id || index}
            //     image={card?.image?.[0]}
            //     totalPrice={card?.price}
            //     area={card?.area}
            //     id={card?.id}
            //     verified={card?.verify_status}
            //     isGeo={true}
            //     postedOn={card?.created_at}
            //     lastUpdate={card?.updated_at}
            //     name={card?.name}
            //     subText={card?.description}
            //     address={`${card?.city?.city_name || ""}, ${
            //       card?.state?.state_name || ""
            //     }`}
            //   />
            // ))
          )}
        </Box>

      </Box>
      {/* Pagination */}
      {marketData.length > 0 && pagination.last_page > 1 && (<Stack direction="row" spacing={1} justifyContent="center" mt={5}>
        {Array.from({ length: pagination.last_page }, (_, i) => i + 1).map(
          (page) => (
            <Button
              key={page}
              variant={
                page === pagination.current_page ? "contained" : "outlined"
              }
              onClick={() => handlePageChange(page)}
            >
              {page}
            </Button>
          )
        )}
      </Stack>)}
    </Container>
  );
}